<template>
    <div class="section pt-1">
        <div class="wallet-card">
            <div class="balance">
                <div class="left">
                    <span class="title mal-text">കരട് ലിസ്റ്റ്</span>
                    <h1 class="total text-primary mal-text">{{ unit.name_mal }}</h1>
                </div>
                <div class="right" v-if="permissions.update">
                    <a href="javascript:void(0);" class="button" @click="openAddModal">
                        <ion-icon name="add-outline"></ion-icon>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <!-- Add/Edit Pledge Modal -->
    <div class="modal fade action-sheet" id="karadModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ isEdit ? 'Edit' : 'Add New' }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label"><span>നിലവിൽ മെമ്പർ ആണോ</span></label>
                                <select class="form-control custom-select" v-model="isMember">
                                    <option value="">---Select---</option>
                                    <option value="Y">അതെ</option>
                                    <option value="N">അല്ല</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group basic typehead-div" v-if="isMember == 'Y' && !isEdit">
                            <div class="input-wrapper">
                                <label class="label">Member</label>
                                <v-select label="text" :filterable="true" v-model="member" :options="member_list"
                                    @search="getTextList">
                                    <template #no-options>type to search...</template>
                                    <template #option="option">
                                        <div class="d-center">{{ option.text }}</div>
                                    </template>
                                </v-select>
                            </div>
                            <div class="input-info" v-if="member">Mobile: {{ member.country_code }} {{ member.mobile }}</div>
                        </div>
                        <div class="form-group basic" v-if="isMember == 'N' || isEdit">
                            <div class="input-wrapper">
                                <label class="label">Name</label>
                                <input type="text" class="form-control" v-model="name" placeholder="Name" autocomplete="off" />
                            </div>
                        </div>
                        <div class="form-group basic" v-if="isMember == 'N' || isEdit">
                            <div class="input-wrapper">
                                <label class="label">Mobile Number</label>
                                <input type="text" class="form-control" v-model="mobile" placeholder="Mobile Number"
                                    autocomplete="off" @input="duplicateMsg = ''; duplicateDetails = null"
                                    @blur="checkMobileDuplicate" />
                                <div v-if="duplicateMsg" class="error-feedback mt-1" style="font-size:13px;">
                                    <div>{{ duplicateMsg }}</div>
                                    <div v-if="duplicateDetails">
                                        <div>{{ duplicateDetails.name }} — {{ duplicateDetails.district_name }}, {{ duplicateDetails.zone_name }}, {{ duplicateDetails.unit_name }} ({{ duplicateDetails.list_type }})</div>
                                        <a v-if="duplicateDetails.mobile" :href="'tel:' + duplicateDetails.mobile"
                                            style="color:red;text-decoration:underline;font-weight:600;">
                                            {{ duplicateDetails.mobile }}
                                        </a>
                                        <div v-if="duplicateDetails.added_by_name" style="margin-top:4px;color:#555;font-size:12px;">
                                            Added by: <b>{{ duplicateDetails.added_by_name }}</b>
                                            <span v-if="duplicateDetails.added_by_mobile"> —
                                                <a :href="'tel:' + duplicateDetails.added_by_mobile"
                                                    style="color:#555;text-decoration:underline;">
                                                    {{ duplicateDetails.added_by_mobile }}
                                                </a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label mal-text">പ്രതീക്ഷിക്കുന്ന സംഭാവന (തുക)</label>
                                <input type="number" class="form-control" v-model="suggested_amount" placeholder="തുക" autocomplete="off" />
                            </div>
                        </div>
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label">Notes</label>
                                <textarea class="form-control" v-model="notes" placeholder="Notes (optional)" rows="2" autocomplete="off"></textarea>
                            </div>
                        </div>

                        <!-- Promote fields shown only on edit -->
                        <template v-if="isEdit">
                            <hr />
                            <p class="mal-text text-muted" style="font-size:13px;">തുക ലഭിച്ചാൽ ഇവിടെ ഫിൽ ചെയ്ത് Submit ചെയ്യുക:</p>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label mal-text">ഈ വ്യക്തി നൽകിയ സംഭാവന</label>
                                    <input type="number" class="form-control" v-model="collected_amount" placeholder="Amount Received" autocomplete="off" />
                                </div>
                            </div>
                            <div class="form-group basic">
                                <div class="input-wrapper">
                                    <label class="label">Receipt Number</label>
                                    <select class="form-control custom-select" v-model="receipt_no">
                                        <option value="">---Select---</option>
                                        <option v-for="n in availableReceiptNumbers" :key="n" :value="n">{{ n }}</option>
                                    </select>
                                </div>
                            </div>
                        </template>

                        <div class="form-group" v-if="message">
                            <div class="error-feedback">{{ message }}</div>
                        </div>
                        <div class="form-group basic">
                            <button v-if="isEdit && collected_amount && receipt_no" type="button" class="btn btn-success btn-block btn-lg mb-1"
                                :disabled="loading" @click="promotePledge">
                                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                <span class="mal-text">Main List-ലേക്ക് Move ചെയ്യുക</span>
                            </button>
                            <button type="button" class="btn btn-primary btn-block btn-lg" :disabled="loading" @click="savePledge">
                                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                <span>Save</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <div class="listed-detail mt-2">
        <h4 class="text-center mt-0 mal-text" v-if="!loading_list && pledges.total <= 0">
            ഇതുവരെ ആരെയും ചേർത്തിട്ടില്ല
        </h4>
    </div>

    <ul class="listview image-listview text inset mt-2" v-if="pledges.data && pledges.data.length">
        <li v-for="(pledge, index) in pledges.data" :key="pledge.id">
            <div class="item">
                <div class="in">
                    <div>
                        <b>{{ index + 1 }}. {{ pledge.name }}</b>
                        <footer>{{ pledge.mobile ? pledge.mobile : '' }}
                            | ₹{{ pledge.suggested_amount }}
                        </footer>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                        <span v-if="pledge.status === 'collected'" class="badge bg-success mal-text">Collected</span>
                        <span v-else class="badge bg-warning text-dark mal-text">Pending</span>
                        <div class="card-button" v-if="permissions.update">
                            <button type="button" class="btn btn-link btn-icon"
                                data-bs-toggle="modal" :data-bs-target="'#karadAction' + pledge.id">
                                <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Action Sheet per item -->
            <div class="modal fade action-sheet" :id="'karadAction' + pledge.id" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ pledge.name }}</h5>
                        </div>
                        <div class="modal-body">
                            <ul class="action-button-list">
                                <li v-if="pledge.mobile">
                                    <a :href="'tel:' + pledge.mobile" class="btn btn-list" data-bs-dismiss="modal">
                                        <span><ion-icon name="call-outline" style="color:#1DCC70;"></ion-icon> Call</span>
                                    </a>
                                </li>
                                <li v-if="pledge.mobile">
                                    <a href="javascript:void(0);" class="btn btn-list" data-bs-dismiss="modal"
                                        @click="openWhatsApp(pledge)">
                                        <span><ion-icon name="logo-whatsapp" style="color:#25D366;"></ion-icon> WhatsApp</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);" class="btn btn-list" data-bs-dismiss="modal"
                                        @click="editPledge(pledge)">
                                        <span><ion-icon name="pencil-outline"></ion-icon> Edit</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);" class="btn btn-list text-danger" data-bs-dismiss="modal"
                                        @click="confirmDelete(pledge)">
                                        <span><ion-icon name="trash-outline"></ion-icon> Remove</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ul>

    <vue-awesome-paginate v-if="pledges.last_page > 1" :total-items="pledges.total" :items-per-page="pledges.per_page"
        :max-pages-shown="3" v-model="currentPage" @click="getPledges" />

    <AlertModel ref="alert_model" :type="alert_type" :message="alert_message" />
    <DialogModel ref="dialog_model" :message="dialog_message" :action_method="dialog_action"
        :action_method_params="dialog_action_params" />
</template>

<script>
/* global bootstrap */
import vSelect from 'vue-select';
import AlertModel from './../layouts/AlertModel.vue';
import DialogModel from './../layouts/DialogModel.vue';
import UserService from '../../services/user.service';

export default {
    name: 'KaradList',
    components: { vSelect, AlertModel, DialogModel },
    data() {
        return {
            loading: false,
            loading_list: false,
            message: '',
            pledges: {},
            karadModal: null,
            unit: {},
            permissions: {},
            isMember: '',
            member: null,
            member_list: [],
            name: '',
            mobile: '',
            suggested_amount: '',
            notes: '',
            collected_amount: '',
            receipt_no: '',
            isEdit: false,
            editable_id: null,
            availableReceiptNumbers: [],
            alert_type: '',
            alert_message: '',
            dialog_message: '',
            dialog_action: '',
            dialog_action_params: {},
            currentPage: 1,
            duplicateMsg: '',
            duplicateDetails: null,
            district_name: '',
            zone_name: '',
        };
    },
    mounted() {
        this.karadModal = new bootstrap.Modal(document.getElementById('karadModal'));
        this.getPledges();
    },
    methods: {
        checkMobileDuplicate() {
            const mobile = String(this.mobile || '').trim();
            if (mobile.length < 10) { this.duplicateMsg = ''; this.duplicateDetails = null; return; }
            UserService.authPostRequest('check-fund-pledge-mobile', {
                mobile,
                fund_type: parseInt(this.$route.params.type),
                editable_id: this.editable_id || null,
            }).then((response) => {
                const data = response.data && response.data.data;
                if (data && data.duplicate) {
                    this.duplicateDetails = data;
                    this.duplicateMsg = 'ഈ നമ്പർ ഇതിനകം ചേർത്തിട്ടുണ്ട്.';
                } else {
                    this.duplicateMsg = '';
                    this.duplicateDetails = null;
                }
            }).catch(() => { this.duplicateMsg = ''; this.duplicateDetails = null; });
        },
        getPledges(page = 1) {
            this.loading_list = true;
            UserService.authPostRequest(`get-fund-pledges?page=${page}`, {
                unit_id: parseInt(this.$route.params.id),
                type: parseInt(this.$route.params.type),
                list_type: 'karad',
            }).then((response) => {
                this.loading_list = false;
                if (response.data.status === 'success') {
                    this.pledges = response.data.data.list;
                    this.unit = response.data.data.unit;
                    this.permissions = response.data.data.permissions;
                    this.district_name = this.unit.district_name || this.unit.district?.name || '';
                    this.zone_name = this.unit.zone_name || this.unit.zone?.name || '';
                    this.$root.updateParent('കരട് ലിസ്റ്റ് - ' + (this.unit.name_mal || ''));
                }
            }, () => { this.loading_list = false; });
        },
        getTextList(search) {
            if (!search) return;
            UserService.authPostRequest('get-typehead-values', {
                q: search,
                type: 0,
                filter: 'inside',
                unit_id: parseInt(this.$route.params.id),
                user_level: 4,
            }).then((response) => {
                if (response.data.status === 'success') {
                    this.member_list = response.data.data.list;
                }
            });
        },
        loadAvailableReceiptNumbers(currentNo = null) {
            const data = {
                fund_type: parseInt(this.$route.params.type),
                unit_id: parseInt(this.$route.params.id),
            };
            if (currentNo) data.current_receipt_no = currentNo;
            UserService.authPostRequest('receipt-book/available-receipt-numbers', data).then((response) => {
                if (response.data.status === 'success') {
                    this.availableReceiptNumbers = response.data.data.numbers || [];
                }
            });
        },
        openAddModal() {
            this.resetForm();
            this.isEdit = false;
            this.loadAvailableReceiptNumbers();
            this.karadModal.show();
        },
        editPledge(pledge) {
            this.resetForm();
            this.isEdit = true;
            this.editable_id = pledge.id;
            this.name = pledge.name;
            this.mobile = pledge.mobile;
            this.suggested_amount = pledge.suggested_amount;
            this.notes = pledge.notes || '';
            this.isMember = pledge.member_id ? 'Y' : 'N';
            this.loadAvailableReceiptNumbers(pledge.receipt_no);
            this.karadModal.show();
        },
        resetForm() {
            this.isMember = '';
            this.member = null;
            this.member_list = [];
            this.name = '';
            this.mobile = '';
            this.suggested_amount = '';
            this.notes = '';
            this.collected_amount = '';
            this.receipt_no = '';
            this.editable_id = null;
            this.message = '';
            this.duplicateMsg = '';
            this.duplicateDetails = null;
        },
        savePledge() {
            if (this.isMember === 'Y' && !this.member) {
                this.alert_type = 'Warning';
                this.alert_message = 'ദയവായി മെമ്പറെ ലിസ്റ്റിൽ നിന്നും സെലക്ട് ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                return;
            }
            if (this.isMember === 'N' && !this.name) {
                this.alert_type = 'Warning';
                this.alert_message = 'ദയവായി പേര് ഫിൽ ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                return;
            }
            if (!this.suggested_amount) {
                this.alert_type = 'Warning';
                this.alert_message = 'ദയവായി തുക ഫിൽ ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                return;
            }
            this.loading = true;
            const data = {
                unit_id: parseInt(this.$route.params.id),
                fund_type: parseInt(this.$route.params.type),
                list_type: 'karad',
                editable_id: this.editable_id,
                suggested_amount: this.suggested_amount,
                notes: this.notes,
                name: this.name,
                mobile: this.mobile,
                member_id: (this.isMember === 'Y' && this.member) ? this.member.id : null,
            };
            UserService.authPostRequest('store-fund-pledge', data).then((response) => {
                this.loading = false;
                if (response.data.status === 'success') {
                    this.karadModal.hide();
                    this.alert_type = 'Success';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                    this.getPledges();
                } else {
                    this.message = response.data.message;
                }
            }, () => { this.loading = false; });
        },
        promotePledge() {
            if (!this.collected_amount || !this.receipt_no) {
                this.alert_type = 'Warning';
                this.alert_message = 'Amount and Receipt Number required.';
                this.$refs.alert_model.openModel();
                return;
            }
            this.loading = true;
            UserService.authPostRequest('promote-fund-pledge', {
                pledge_id: this.editable_id,
                amount: this.collected_amount,
                receipt_no: this.receipt_no,
            }).then((response) => {
                this.loading = false;
                if (response.data.status === 'success') {
                    this.karadModal.hide();
                    this.alert_type = 'Success';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                    this.getPledges();
                } else {
                    this.message = response.data.message;
                }
            }, () => { this.loading = false; });
        },
        openWhatsApp(pledge) {
            const url = this.whatsappLink(pledge);
            setTimeout(() => { window.open(url, '_blank'); }, 300);
        },
        whatsappLink(pledge) {
            const unitName = this.unit.name_mal || this.unit.name || '';
            const msg = `*Wisdom Youth Da'wa Fund* 🌟\n\nഅസ്സലാമു അലൈക്കും ${pledge.name},\n\nതാഴെ നൽകിയ ലിങ്ക് വഴി നിങ്ങളുടെ സംഭാവന ഓൺലൈനായി നൽകാവുന്നതാണ്:\n\n🔗 https://guideportal.wisdomislam.org/donation/unit_youth_dawa_fund\n\nഫോം ഫിൽ ചെയ്യുമ്പോൾ ഇനിപ്പറയുന്നവ സെലക്ട് ചെയ്യുക:\n🏛️ District: ${this.district_name}\n📍 Zone: ${this.zone_name}\n🏠 Unit: ${unitName}\n\nജസാക്കല്ലാഹ് ഖൈർ 🤲`;
            const mobile = String(pledge.mobile).replace(/\D/g, '');
            const number = mobile.startsWith('91') ? mobile : '91' + mobile;
            return `https://wa.me/${number}?text=${encodeURIComponent(msg)}`;
        },
        confirmDelete(pledge) {
            this.dialog_action_params = { id: pledge.id };
            this.dialog_message = 'ഈ എൻട്രി ഡിലീറ്റ് ചെയ്യണോ?';
            this.dialog_action = 'deletePledge';
            this.$refs.dialog_model.openModel();
        },
        deletePledge(data) {
            UserService.authPostRequest('delete-fund-pledge', data).then((response) => {
                if (response.data.status === 'success') {
                    this.alert_type = 'Success';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                    this.getPledges();
                } else {
                    this.alert_type = 'Warning';
                    this.alert_message = response.data.message;
                    this.$refs.alert_model.openModel();
                }
            });
        },
    },
};
</script>

<style scoped>
.error-feedback { color: red; }
.listview { margin-bottom: 0; }
</style>
